// SPDX-License-Identifier: AGPL-3.0-or-later

// LOCAL-ONLY: the app's calendar store, wired to the REST client, this device's banner dismissals and the window's
// visibility and focus (calendar-plan.md section 11's refresh points). READY (AccountReadyWork) and RESUMED
// (EventRouter) call in. Exclude from upstream sync.

import {RestCalendarApi} from '@app/features/calendar/CalendarApi';
import {DeviceBannerDismissals} from '@app/features/calendar/CalendarBanner';
import type {CalendarEventWriter} from '@app/features/calendar/CalendarEventEditor';
import {CalendarState} from '@app/features/calendar/state/CalendarState';

const isHidden = (): boolean => typeof document !== 'undefined' && document.visibilityState === 'hidden';

const Calendar = new CalendarState({api: RestCalendarApi, dismissals: DeviceBannerDismissals, isHidden});

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	document.addEventListener('visibilitychange', () => {
		if (isHidden()) Calendar.handleHidden();
		else Calendar.handleFocus();
	});
	window.addEventListener('focus', () => Calendar.handleFocus());
}

export const CalendarWriter: CalendarEventWriter = {
	create: (body) => Calendar.createEvent(body),
	update: (eventId, body) => Calendar.updateEvent(eventId, body),
	remove: (eventId) => Calendar.deleteEvent(eventId),
};

export default Calendar;
